import { render } from "./PatientsTable.vue?vue&type=template&id=7f2fec88&scoped=true"
import script from "./PatientsTable.vue?vue&type=script&lang=js"
export * from "./PatientsTable.vue?vue&type=script&lang=js"

import "./PatientsTable.vue?vue&type=style&index=0&id=7f2fec88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2fec88"]])

export default __exports__